/* eslint-disable @typescript-eslint/ban-ts-comment */
import styles from './ConsultaMedicamentos.module.less';
import BannerWithImage from 'components/BannerWithImage';
import { I18nt } from 'utils';
import { Button } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';
import { useConsultaMedicamentos } from '../ConsultaMedicamentosContext';
import jsPDF from 'jspdf';
const doc = new jsPDF({ format: 'letter' });

const ConfirmationView = () => {
	const { resetState, reservaConfirmationData: reserva } =
		useConsultaMedicamentos();

	if (!reserva) {
		return null;
	}
	const [fecha, hora, ampm] = reserva.hora.split(' ');
	const data = {
		paciente: `${reserva.receta.nombrePaciente} ${reserva.receta.apellidoPaciente}`,
		numero_de_afiliación: reserva.receta.idAfiliado ?? '',
		dui: reserva.receta.dui ?? '',
		lugar: reserva.lugar,
		fecha: fecha,
		hora: `${hora} ${ampm}`,
		medicamento: reserva.medicamento,
	};

	const printPdf = () => {
		let y = 40;
		doc.setFontSize(16);
		//@ts-ignore
		doc.text(I18nt('comprobante_de_reserva'), 105, 30, null, null, 'center');
		doc.setFontSize(10);
		//@ts-ignore
		doc.text(I18nt('isbm'), 105, 35, null, null, 'center');
		doc.setFontSize(11);
		for (const key in data) {
			y += 7;
			//@ts-ignore
			doc.text(`${I18nt(key)}: ${data[key]}`, 50, y, null, null, 'left');
		}
		doc.setFontSize(13);
		//@ts-ignore
		doc.text(`${I18nt('indicaciones')}:`, 50, y + 14, null, null, 'left');
		doc.setFontSize(10);
		doc.text(
			`${I18nt('pdf_instructions_medicamento_1')}`,
			50,
			y + 21,
			null,
			null,
			//@ts-ignore
			'left'
		);
		doc.text(
			`${I18nt('pdf_instructions_medicamento_2')}`,
			50,
			y + 28,
			null,
			null,
			//@ts-ignore
			'left'
		);
		doc.save('comprobante_de_reserva.pdf');
	};

	return (
		<BannerWithImage className={styles.confirmView}>
			<div className={styles.confirmWrapper}>
				<div className={styles.buttonWrapper}>
					<Button className={styles.goBackBtn} onClick={resetState} type='link'>
						<ArrowLeftOutlined />
						{I18nt('regresar_al_formulario')}
					</Button>
				</div>
				<div className={styles.centerBox}>
					<div className={styles.whiteBg}>
						<h4 className={styles.reserveTitle}>
							{I18nt('medicamento_reservado')}
						</h4>
						<p
							className={styles.reminderText}
							dangerouslySetInnerHTML={{
								__html: I18nt('recuerda_pasar_por_medicamento'),
							}}
						/>
						<div className={styles.downloadContainer}>
							<p>{I18nt('descargar_comprobante_botiquin')}</p>
							<button onClick={printPdf} className={styles.download}>
								<DownloadOutlined />
								{I18nt('descargar_comprobate_reserva')}
							</button>
						</div>
					</div>
					<div>
						<p
							className={styles.updateText}
							dangerouslySetInnerHTML={{
								__html: I18nt('puedes_modificar_reserva'),
							}}
						/>
					</div>
				</div>
			</div>
		</BannerWithImage>
	);
};

export default ConfirmationView;
